import * as React from 'react';
const ConfirmIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.645 6.682a.5.5 0 0 0-.707-.707L9.975 12.94l-1.84-1.84-.004-.004L6.67 9.634a.5.5 0 0 0-.708.707l1.11 1.11-1.488 1.488-2.939-2.94a.5.5 0 1 0-.707.708l2.983 2.982a.94.94 0 0 0 1.327 0l1.531-1.531 1.532 1.531a.94.94 0 0 0 1.327 0zm-4.39 0a.5.5 0 1 0-.707-.707L9.62 8.902a.5.5 0 0 0 .707.707z"
      fill="currentColor"
    />
  </svg>
);
export default ConfirmIcon;
